
export function MobileTabItem({ slug, currentTab, setTab, children }) {
    return (<li
        data-slug={slug}
        onClick={() => setTab(slug)}
        className={currentTab === slug ? 'meuselfstorage__calculadora__mobile-header__categories__category--active' : ''}
    >
        <span>{children}</span>
    </li>);
}
